<template>
  <div
    ref="marqueeRoot"
    class="marquee"
    @mouseenter="pause"
    @mouseleave="resume"
  >
    <div
      ref="marqueeContent"
      class="marquee__content"
      :style="{ transform: `translate3d(${offset}px, 0, 0)` }"
    >
      <div ref="slotWrapper" class="marquee__item-wrapper">
        {{ text }}
      </div>
      <div v-for="n in clones"
           :key="'clone-' + n"
           class="marquee__item-wrapper"
      >
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseTextBillboard",
  props: {
    text: {type: String, required: true},
    speed: {type: Number, default: 0.8},
    direction: {type: String, default: "left"}
  },
  data() {
    return {
      offset: 0,
      clones: 0,
      isPaused: false,
      animationFrameId: null,
      interval: 1000 / 60,
      then: Date.now()
    };
  },
  watch: {
    text() {
      this.$nextTick(() => this.calculateClones());
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calculateClones();
      window.addEventListener("resize", this.calculateClones);
      if (this.clones > 0) this.start();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateClones);
    this.stop();
  },
  methods: {
    calculateClones() {
      const wrapper = this.$refs.slotWrapper;
      const root = this.$refs.marqueeRoot;
      if (!wrapper || !root) return;

      const wrapperWidth = wrapper.offsetWidth;
      const containerWidth = root.offsetWidth;

      if (wrapperWidth <= containerWidth) {
        this.clones = 0;
        this.offset = 0;
        this.stop();
        return;
      }

      this.clones = Math.ceil(containerWidth / wrapperWidth) + 1;
      if (!this.animationFrameId) this.start();
    },
    start() {
      if (!this.animationFrameId) {
        this.then = Date.now();
        this.animate();
      }
    },
    stop() {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    },
    animate() {
      if (!this.isPaused && this.clones > 0) {
        const now = Date.now();
        const delta = now - this.then;

        if (delta > this.interval) {
          this.then = now - (delta % this.interval);
          const content = this.$refs.marqueeContent;

          if (this.direction === "left") {
            const firstWrapper = content.firstElementChild;
            const firstRight = firstWrapper.getBoundingClientRect().right;
            const rootLeft = this.$refs.marqueeRoot.getBoundingClientRect().left;

            if (firstRight <= rootLeft) {
              this.offset = -1;
              content.appendChild(firstWrapper);
            }
            this.offset -= this.speed;
          } else {
            const lastWrapper = content.lastElementChild;
            const lastLeft = lastWrapper.getBoundingClientRect().left;
            const rootRight = this.$refs.marqueeRoot.getBoundingClientRect().right;

            if (lastLeft >= rootRight) {
              this.offset -= lastWrapper.offsetWidth;
              content.insertBefore(lastWrapper, content.firstElementChild);
            }
            this.offset += this.speed;
          }
        }
      }

      this.animationFrameId = requestAnimationFrame(this.animate);
    },
    pause() {
      this.isPaused = true;
      this.stop();
    },
    resume() {
      this.isPaused = false;
      this.start();
    }
  }
};
</script>

<style scoped>
.marquee {
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 100%;
  display: flex;
  align-items: center;
}

.marquee__content {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  will-change: transform;
}

.marquee__item-wrapper {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  padding-right: 15px;
}
</style>
